import { writable } from 'svelte/store';
import type { Suggestion } from '../actions/getSuggestions';

export const suggestions = writable<Array<Suggestion>>([]);
